var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditPencilLightGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36861 12.0115C5.74467 12.3875 6.35439 12.3875 6.73045 12.0115L14.1813 4.56067C14.767 3.97488 14.767 3.02513 14.1813 2.43934C13.5955 1.85355 12.6457 1.85355 12.0599 2.43934L4.60912 9.89015C4.23306 10.2662 4.23306 10.8759 4.60912 11.252L5.36861 12.0115ZM3.53367 11.5907C3.38135 11.4384 3.1241 11.483 3.0319 11.6777L2.06675 13.7156C1.94132 13.9805 1.99592 14.2956 2.20313 14.5028C2.41812 14.7178 2.74807 14.7677 3.017 14.6259L4.98612 13.5874C5.16305 13.4941 5.19903 13.2561 5.05759 13.1146L3.53367 11.5907Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditPencilLightGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit_pencil_light_grey.a593375726714e918afbd9e65bcdc08e.svg";